import { useContext } from "react";
import EntryPage from "./routes/EntryPage.js";
import SendAuthCode from "./routes/SendAuthCode.js";

import Context from "../../Context.js";
import getPopupType from "../../controllers/getPopupType.js";
import styled from "styled-components";

import PageNotFound from "../helperComponents/PageNotFound.js";
import ForgotPassword from "../pages/loggedOut/auth/ForgotPassword.js";
import ChangePassword from "../pages/loggedOut/auth/ChangePassword.js";
import SettingsPage from "../pages/loggedIn/settings/SettingsPage.js";

import EditProfile from "../pages/loggedIn/onboarding/EditProfile.js";

import LoginWall from "../pages/loggedIn/LoginWall.js";
import TermsAndCondition from "../pages/foooterPages/TermsAndCondition.js";
import PrivacyPolicy from "../pages/foooterPages/PrivacyPolicy.js";
import RefundPolicy from "../pages/foooterPages/RefundPolicy.js";
import VerifyEmail from "../pages/loggedIn/onboarding/VerifyEmail.js";

import DeleteAccount from "../pages/deleteAccount/DeleteAccount.js";
import EmployeeListPage from "../pages/loggedIn/employees/EmployeeListPage.js";
import AddOrEditEmployee from "../pages/loggedIn/employees/AddOrEditEmployee.js";
import EmployeeProfile from "../pages/loggedIn/employees/EmployeeProfile.js";
import SiteListPage from "../pages/loggedIn/sites/SiteListPage.js";
import SitePage from "../pages/loggedIn/sites/SitePage.js";
import AddOrEditSite from "../pages/loggedIn/sites/AddOrEditSite.js";
import RolePage from "../pages/loggedIn/roles/RolePage.js";
import RoleListPage from "../pages/loggedIn/roles/RoleListPage.js";
import AddOrEditRole from "../pages/loggedIn/roles/AddOrEditRole.js";
import AddOrEditZone from "../pages/loggedIn/zones/AddOrEditZone.js";
import ZoneListPage from "../pages/loggedIn/zones/ZoneListPage.js";
import ZonePage from "../pages/loggedIn/zones/ZonePage.js";
import AddOrEditAbsence from "../pages/loggedIn/absence/AddOrEditAbsence.js";
import AddOrEditComment from "../pages/loggedIn/comment/AddOrEditComment.js";
import AddOrEditDispute from "../pages/loggedIn/disputes/AddOrEditDispute.js";
import AddOrEditVacation from "../pages/loggedIn/vacation/AddOrEditVacation.js";
import Nomenclature from "../pages/loggedIn/nomenclature/Nomenclature.js";
import UserActivitiesListPage from "../pages/loggedIn/userActivities/UserActivitiesListPage.js";
import LoginWithOTP from "../pages/loggedOut/auth/LoginWithOTP.js";
import GenerateOTP from "../pages/loggedOut/auth/GenerateOTP.js";
import LoginPage from "../pages/loggedOut/auth/LoginPage.js";
import FirstSignup from "../pages/loggedOut/auth/FirstSignup.js";
import CommentListPage from "../pages/loggedIn/comment/CommentListPage.js";
import SearchPage from "../pages/loggedIn/search/SearchPage.js";
import NewNomenclaturePage from "../pages/loggedIn/nomenclature/NewNomenclaturePage.js";
import OptionsPageForMobile from "../pages/loggedIn/settings/OptionsPageForMobile.js";
import AttendancePage from "../pages/loggedIn/nomenclature/AttendancePage.js";
import DailyResponsibilityPage from "../pages/loggedIn/nomenclature/DailyResponsibilityPage.js";
import Migration from "../pages/migration/Migration.js";
import VacationListPage from "../pages/loggedIn/vacation/VacationListPage.js";
import AbsenceListPage from "../pages/loggedIn/absence/AbsenceListPage.js";
import FunctionsPage from "../pages/loggedIn/functions/FunctionsPage.js";

const Container = styled.div`
  /* min-height: 100%; */ //don't enable this, it prevents the scroll from the working that is assigned in the boilerplate
  //especially for the logged out page

  /* overflow-y: scroll; */
  /* height: calc(100dvh - var(--safe-area-inset-top)); */
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  /* @media (max-width: 900px) {
    width: 100vw;
  } */
`;

let pathVsComp = {
  "/": <EntryPage />,
  "/edit-profile": <EditProfile />,

  //Auth
  "/options": <OptionsPageForMobile />,
  "/auth-redirect": <SendAuthCode />,
  "/auth": <LoginPage />,
  "/forgot-password": <ForgotPassword />,
  "/change-password": <ChangePassword />,
  "/settings": <SettingsPage />,
  "/delete-account": <DeleteAccount />,
  "/generate-otp": <GenerateOTP />,
  "/login-with-otp": <LoginWithOTP />,
  "/first-signup": <FirstSignup />,

  //Employee
  "/employee": <EmployeeProfile />,
  "/employees": <EmployeeListPage />,
  "/add-employee": <AddOrEditEmployee />,
  "/edit-employee": <AddOrEditEmployee />,

  //Sites
  "/site": <SitePage />,
  "/sites": <SiteListPage />,
  "/add-site": <AddOrEditSite />,
  "/edit-site": <AddOrEditSite />,

  "/functions": <FunctionsPage />,

  //Role
  "/role": <RolePage />,
  "/roles": <RoleListPage />,
  "/add-role": <AddOrEditRole />,
  "/edit-role": <AddOrEditRole />,

  //Zone
  "/zone": <ZonePage />,
  "/zones": <ZoneListPage />,
  "/add-zone": <AddOrEditZone />,
  "/edit-zone": <AddOrEditZone />,

  //Footer Pages
  "/confirm-email": <VerifyEmail />,
  "/terms-and-conditions": <TermsAndCondition />,
  "/privacy-policy": <PrivacyPolicy />,
  "/refund-policy": <RefundPolicy />,

  "/add-absence": <AddOrEditAbsence />,
  "/edit-absence": <AddOrEditAbsence />,

  "/add-dispute": <AddOrEditDispute />,
  "/edit-dispute": <AddOrEditDispute />,

  "/add-comment": <AddOrEditComment />,
  "/edit-comment": <AddOrEditComment />,
  "/comments": <CommentListPage />,

  "/add-vacation": <AddOrEditVacation />,
  "/edit-vacation": <AddOrEditVacation />,
  "/vacations": <VacationListPage />,
  "/user-activities": <UserActivitiesListPage />,

  "/search": <SearchPage />,

  //Nomenclature
  // "/nomenclature": <Nomenclature />,
  "/nomenclature": <AttendancePage />,
  "/daily-staff-presentation": <DailyResponsibilityPage />,
  "/presence-list": <NewNomenclaturePage />,
  "/absences": <AbsenceListPage />,
  //
  "/migration": <Migration />,
};

let loginNotRequiredPages = [
  "/",
  "/confirm-email",

  "/auth-redirect",
  "/auth",

  "/signup",
  "/forgot-password",

  "/change-password",
  "/privacy-policy",

  "/terms-and-conditions",
  "/refund-policy",

  "/buy-membership",
  "/buy-activity",

  "/activity-type",
  "/store-item",
  "/generate-otp",
  "/login-with-otp",
  "/first-signup",
];

export default function CustomRouter() {
  const { currentRoute, nonPopupRoute, loggedInUserID } = useContext(Context);

  let popupComp = null;
  let baseComp = findCompOfPath(currentRoute);

  let popupType = getPopupType(currentRoute);

  if (popupType && nonPopupRoute) {
    if (currentRoute !== nonPopupRoute) {
      baseComp = findCompOfPath(nonPopupRoute);
      popupComp = getPopupComp(currentRoute);
    }
  }

  let containerStyle = null;

  if (popupComp) {
    containerStyle = { display: "none" };
  }

  return (
    <>
      <Container style={containerStyle}>
        {baseComp ? baseComp : <PageNotFound />}
      </Container>
      {popupComp}
    </>
  );

  function findCompOfPath(pathToScan) {
    pathToScan = pathToScan.split("?")[0];

    //Remove last slash
    let lastItem = pathToScan[pathToScan.length - 1];
    if (lastItem == "/" && pathToScan !== "/")
      pathToScan = pathToScan.slice(0, pathToScan.length - 1);

    if (pathToScan == "/") return pathVsComp["/"];

    let matchedComponents = [];
    let pathToScanSplit = pathToScan.split("/");
    if (pathToScanSplit.length <= 1) return null;
    //the first item is null. So we need path with at least a length of 2

    /*
    Explanation of the following code

    Let's say the path is /part1/part2/part3

    the following code first check /part1
    then checks /part1/part2
    then checks /part1/part2/part3

    all of the is put in an array
    the array is reversed
    & we just use first match from the reversed array


 */

    for (let i = 1; i < pathToScanSplit.length; i++) {
      // console.log("i", i);

      if (i === 1) {
        let subPathString = pathToScanSplit[i];

        // console.log("subPathString 1", subPathString);

        let matchedComp = pathVsComp["/" + subPathString];
        if (matchedComp) {
          matchedComponents.push(matchedComp);
        }
      } else {
        let subPathArray = [];

        for (let j = 1; j <= i; j++) {
          subPathArray.push(pathToScanSplit[j]);
        }
        let pathString = subPathArray.join("/");

        let matchedComp = pathVsComp["/" + pathString];
        if (matchedComp) {
          matchedComponents.push(matchedComp);
        }
      }
    }

    let baseRoute = "/" + pathToScan.split("/")[1];

    if (matchedComponents.length) {
      if (!loginNotRequiredPages.includes(baseRoute)) {
        if (!loggedInUserID) {
          return <LoginWall />;
        }
      }
    }

    if (!matchedComponents.length) {
      return null;
    }

    matchedComponents.reverse();

    return matchedComponents[0];
  }

  function getPopupComp(pathName) {
    return false;
  }
}
